<template>
  <div>
    <a-modal :title="title" :visible.sync="visible" @ok="submit" @cancel="reset" width="500px">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="角色名称">
          <a-input v-model="form.roleName" placeholder="请输入角色名名称" />
        </a-form-model-item>
        <a-form-model-item label="角色代码">
          <a-input v-model="form.roleKey" placeholder="请输入角色代码" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { saveRole, updateRole, getRole } from '@/api/system/role'

export default {
  name: 'role-edit',
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      title: '新增角色',
      mode: undefined,
      visible: false,
      submitLoading: false,
      form: {
        id: undefined,
        roleName: undefined,
        roleKey: undefined,
      },
      rules: {
        roleName: [{ required: true, message: '请输入角色名名称', trigger: 'blur' }],
        roleKey: [{ required: true, message: '请输入角色代码', trigger: 'blur' }],
      },
    }
  },
  methods: {
    //打开编辑窗口
    open(id) {
      this.visible = true
      if (!id) {
        this.title = '新增角色'
        this.mode = 'add'
      } else {
        this.title = '修改角色'
        this.mode = 'update'
        getRole(id).then(response => {
          this.form = response.data.result
        })
      }
    },
    //新增
    submit: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let para = this.form
          if (!para.id) {
            saveRole(para).then(({ data }) => {
              this.$message.success('操作成功')
              this.form = {
                id: undefined,
                roleName: undefined,
                roleKey: undefined,
              }
              this.visible = false
              this.submitLoading = false
              this.$parent.dataLoad()
            })
          } else {
            updateRole(para).then(({ data }) => {
              this.$message.success('操作成功')
              this.form = {
                id: undefined,
                roleName: undefined,
                roleKey: undefined,
              }
              this.visible = false
              this.submitLoading = false
              this.$parent.dataLoad()
            })
          }
        }
      })
    },
    reset() {
      this.form = {
        id: undefined,
        roleName: undefined,
        roleKey: undefined,
      }
      this.visible = false
    },
  },
}
</script>
<style></style>
